<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Fecha de Solicitud</label>
            <b-form-input
              type="date"
              v-model="fechaSolicitud"
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Correlativo</label>
            <b-form-input 
                v-model="correlativo" 
                placeholder="Correlativo" 
                @input="filter"/>
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2">
            <label>Establecimiento Origen</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="selectedLocal"
              :options="locals"
              label="name"
              placeholder="Seleccion establecimiento"
              :reduce="(locals) => locals.id"
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Estado</label>
            <v-select
              v-model="state"
              :options="states"
              label="name"
              placeholder="Seleccionar Estado"
              @input="filter"
            />
          </b-col>
          <b-col md="3" class="mt-2 justify-content-end d-flex">
            <b-button
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <span class="align-middle">Borrar</span>
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click.prevent="agregar"
            >
              <span class="align-middle">Agregar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import StoresService from '@/services/StoresService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      fechaSolicitud: '',
      correlativo: '',
      state: null,
      selectedLocal: null,
      locals: [],
      arrayFilters: [],
      userEstablishments: [],
      datosUser: null,
      states: [
        { name: 'Cotizacion' },
        { name: 'Pre-venta' },
        { name: 'Caja' },
      ],
    };
  },
  mounted() {
    this.getLocals()
    this.datosUser = JSON.parse(localStorage.getItem('userData'))
    this.userEstablishments = this.datosUser?.data?.userEstablishments || []
    this.userEstablishments = this.userEstablishments.map(establishment => establishment.id)
    console.log("my stablishments", this.userEstablishments)
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  methods: {
    async getLocals() {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const userEstablishments = userData?.data?.userEstablishments || [];

      this.locals = userEstablishments.map(est => ({
        id: est.id,
        name: est.name,
      }));

    },

    filter() {
      this.arrayFilters = [];

      if (this.fechaSolicitud) {
        const startOfDay = new Date(this.fechaSolicitud);
        startOfDay.setHours(0, 0, 0, 0);
        startOfDay.setDate(startOfDay.getDate() + 1);

        const endOfDay = new Date(this.fechaSolicitud);
        endOfDay.setHours(0, 0, 0, 0);
        endOfDay.setDate(endOfDay.getDate() + 2);

        this.arrayFilters.push({
          keyContains: 'updated_at',
          key: 'gte',
          value: startOfDay, 
        });

        this.arrayFilters.push({
          keyContains: 'updated_at',
          key: 'lt', 
          value: endOfDay, 
        });
      }

      console.log("selectedLocal", this.selectedLocal)

      if (this.selectedLocal) {
        this.arrayFilters.push({
          keyContains: 'establishmentOriginId',
          key: 'equals',
          value: this.selectedLocal,
        });
      }

      if (this.correlativo) {
        this.arrayFilters.push({
          keyContains: 'correlative',
          key: 'contains',
          value: this.correlativo
        });
      }

      if (this.state) {
        this.arrayFilters.push({
          keyContains: 'state',
          key: 'equals', 
          value: this.state.name,
        });
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    },
    agregar(){
      this.$router.push({ name: 'proforma-add' })
    },

    clean() {
      this.fechaSolicitud = '';
      this.correlativo = '';
      this.selectedLocal = null;
      this.state = null;
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>